import React from 'react';
import { Button } from 'react-bootstrap';
import Table from '../Table';
import Pager from '../Pager';
import FlowSource from '../../sources/flow';
import { bindMethods } from '../../utils/core';
import { pipe, slice } from 'ramda';

const initialState = {
    // This is all the snapshots/published versions of the flow from api/draw/1/flow/snap/
    // Used to list all of the past snapshots/published versions
    isLoadingSnapshots: true,
    allSnapshots: [],
    visibleSnapshots: [],
    page: 1,
    pageSize: 10,
    total: 0,
};

class VersionSection extends React.Component {
    constructor() {
        super();

        this.state = initialState;

        bindMethods(
            this,
            // // Data Loading
            'reloadFlowSnapshots',
            'activateFlowSnapshot',
            // Data changing
            'querySnapshots',
        );
    }

    
    componentDidMount() {
        this.reloadFlowSnapshots();
    }
    
    // queries the given collection of flows by supplied params
    // returns an object containing total number matching the search query
    // and filtered/paged collection of results
    querySnapshots({ 
        allSnapshots,
        page, 
        pageSize,
    }) {

        const startAt = (page - 1) * pageSize;
        const endAt = startAt + pageSize;

        const total = allSnapshots.length;

        const visibleSnapshots = pipe(
            slice(startAt, endAt),
        )(allSnapshots);

        this.setState({ page, visibleSnapshots, total });
    }

    reloadFlowSnapshots() {
        this.setState({ isLoadingSnapshots: true });
        FlowSource.getSnapshots(this.props.flowId, this.props.tenantId, this.props.authenticationToken)
            .then(
                (allSnapshots) => {
                    this.setState({ allSnapshots, isLoadingSnapshots: false });
                    this.querySnapshots({ allSnapshots, page: this.state.page, pageSize: this.state.pageSize });
                },
            ).catch(
                error => this.props.addNotification({
                    type: 'error',
                    message: error.message,
                    isPersistent: true,
                }),
            );
    }

    activateFlowSnapshot(flowId, flowVersionId) {
        this.setState({ isLoadingSnapshots: true });
        FlowSource.activateFlowSnapshot(flowId, flowVersionId, this.props.tenantId, this.props.authenticationToken)
            .then(
                this.reloadFlowSnapshots,
            ).catch(
                error => this.props.addNotification({
                    type: 'error',
                    message: error.message,
                    isPersistent: true,
                }),
            );
    }

    render() {
        const versionTitle = (
            <React.Fragment>
                <h2>Snapshots</h2>
                <span className="body-text">
                    <p>Activate a previously built snapshot of the Flow.</p>
                    <p>A snapshot is a version of a Flow which is created every time you "Build &amp; Run" or "Publish" a Flow.</p>
                    <p>Activating a snapshot will only change the version of the Flow that users see when they run this Flow without a specific version id.</p>
                    <p>The build version will not be affected.</p>
                </span>
            </React.Fragment>
        );

        if (this.state.isLoadingSnapshots || !this.state.allSnapshots) {
            return (
                <React.Fragment>
                    <div className="wait-container-wrapper">
                        {React.createElement(manywho.component.getByName('wait'), { isVisible: true, message: 'Loading snapshots' }, null)}
                    </div>
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                {versionTitle}
                <div className="mw-items-header">
                    <Button 
                        className="btn btn-default btn-sm" 
                        title="Refresh Snapshots"
                        onClick={this.reloadFlowSnapshots}
                    >
                        <span className="glyphicon glyphicon-refresh" />
                    </Button>
                </div>
                <Table 
                    className="table scroll-table-entry margin-top"
                    columns={
                        [
                            {
                                renderHeader: () => 'Actions',
                                renderCell: ({ item }) => (
                                    item.isDefault ? 
                                    (
                                        <span className="button-padding-left-container">
                                            <span className="glyphicon glyphicon-check glyphicon-margin-right" />
                                            Activated
                                        </span>
                                    ) :
                                    <Button 
                                        className="btn btn-sm btn-primary"
                                        title="Activate Flow Snapshot" 
                                        onClick={() => this.activateFlowSnapshot(item.id.id, item.id.versionId)}
                                    >
                                        <React.Fragment>
                                            <span className="glyphicon glyphicon-unchecked glyphicon-margin-right" />
                                            Activate Flow Snapshot
                                        </React.Fragment>
                                    </Button>),
                            },
                            {
                                renderHeader: () => 'Date Activated',
                                renderCell: ({ item }) => moment(item.dateCreated).format("MMMM Do YYYY, hh:mm:ss"),
                            },
                            {
                                renderHeader: () => 'Comment',
                                renderCell: ({ item }) => item.comment,
                            },
                        ]
                    }
                    items={this.state.visibleSnapshots}
                    rowClassName={() => "button-height-container"}
                />
                <Pager
                    page={this.state.page}
                    pageSize={this.state.pageSize}
                    total={this.state.total}
                    onPageClick={page => this.querySnapshots({ allSnapshots: this.state.allSnapshots, page, pageSize: this.state.pageSize })} 
                />
            </React.Fragment>
        );
    }
}

export default VersionSection;
